import Steps from './Steps'
import StepsItem from './StepsItem'
import StepsSeparator from './StepsSeparator'

Steps.Item = StepsItem
Steps.Separator = StepsSeparator

export default Steps
